import React from 'react';
import { Document, Page, Text, View, StyleSheet, } from '@react-pdf/renderer';

export const PdfExample = ({ }) => {

    // Create styles
    const styles = StyleSheet.create({
        page: {
            flexDirection: 'row',
            width: '100vh',
            height: '100vh'
        },
        section: {
            margin: 10,
            padding: 10,
            flexGrow: 1
        },
        xx:{
            fontSize:'24',
            textAlign:'center'
        }
    });

    return (
        <Document >
            <Page size="A4" >
                <View style={styles.section}>
                    <Text style={styles.xx}>
                        Section #1
                    </Text>
                    <View style={styles.section}>
                        <Text style={styles.xx}>
                            col #1
                        </Text>
                        <Text style={styles.xx}>
                            col #2
                        </Text>
                        <Text style={styles.xx}>
                            col #3
                        </Text>
                    </View>

                </View>
            </Page>
            <Page size="A4">
                <View style={styles.section}>
                    <Text>Section #2</Text>
                </View>
            </Page>
        </Document>
    )
}
